import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Stack,
  useTheme
} from '@mui/material';
import useResponsive from '@/hooks/useResponsive';
import Typography from '@/components/Typography';
import { useRouter } from 'next/router';
import { QuestionsT } from './types';
import { ArrowDown2 } from 'iconsax-react';
import getLocalFile from '@/utils/getLocalFile';

type QuestionComponentProps = {
  isPricePage?: boolean;
};
const QuestionComponent = ({ isPricePage }: QuestionComponentProps) => {
  const { matches } = useResponsive();
  const theme = useTheme();

  const {
    query: { symbol }
  } = useRouter();
  const marketName = symbol?.toString().toUpperCase() || '';
  const data = getLocalFile(marketName, 'info');

  return (
    <>
      <Box
        sx={{
          mb: matches({ xs: 3, lg: 3 }),
          mt: matches({ xs: 0, lg: 1.5 }),
          width: matches({ xs: '100vw', lg: '100%' }),
          borderTop: matches({ xs: ' 4px solid #F8FAFD', lg: 'unset' }),
          borderBottom: matches({ xs: ' 4px solid #F8FAFD', lg: 'unset' })
        }}
      >
        <Stack
          gap={3}
          itemScope
          // itemType="https://schema.org/FAQPage"
          sx={{ padding: matches({ xs: 4, lg: 6 }) }}
        >
          <Typography
            variant={matches({ xs: 'body1', lg: 'title' })}
            weight="bold"
            component="h2"
            textAlign="start"
            sx={{ pb: matches({ lg: 0, xs: 5 }) }}
          >
            {isPricePage
              ? `سوالات متداول قیمت ${data.Information.name_fa}`
              : `سوالات متداول خرید ${data.Information.name_fa}`}
          </Typography>
          <Stack direction="column">
            {data?.questions.map((item: QuestionsT, index: number) => (
              <Accordion
                itemScope
                itemProp="mainEntity"
                // itemType="https://schema.org/Question"
                elevation={0}
                key={index}
                sx={{
                  borderBottom: '1px solid #EFF2F5',
                  paddingY: 3,
                  paddingX: 0
                }}
              >
                <AccordionSummary
                  aria-controls={`panel1a-content${index}`}
                  expandIcon={<ArrowDown2 size="20" color="#16181F" />}
                  id={`accordion-${index}`}
                >
                  <Typography
                    itemProp="name"
                    variant={matches({ lg: 'body2', xs: 'body5' })}
                    weight="normal"
                    component="h3"
                    color="#222531"
                  >
                    {item.title}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  itemScope
                  itemProp="acceptedAnswer"
                  // itemType="https://schema.org/Answer"
                  sx={{ justifyContent: 'start', pt: 0, pb: 3 }}
                >
                  <Typography
                    itemProp="text"
                    // variant={matches({ lg: 'body2', xs: 'body3' })}
                    color="#58667E"
                    sx={{
                      fontSize: 12,
                      lineHeight: '24px'
                    }}
                    component="p"
                  >
                    {item.description}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Stack>
        </Stack>
      </Box>
    </>
  );
};

export default QuestionComponent;
